import { Badge } from '@/components/ui';
import type { HumanReviewRequest } from '@/lib/admin/client';

import {
  confidenceBadgeVariant,
  humanReviewStateBadgeVariant,
  impactBadgeVariant,
  priorityBadgeVariant,
} from './badgeVariants';
import { payloadImpactLevel } from './payloadRenderers';
import { humanizeSubjectType, subjectTypeChipVariant } from './subjectType';

export type HumanReviewRequestChipsProps = { item: HumanReviewRequest };

export function HumanReviewRequestChips({
  item,
}: HumanReviewRequestChipsProps) {
  const impactLevel = payloadImpactLevel(item);
  const isAutoDecided = item.decisionSource === 'policy';

  return (
    <div className="flex flex-wrap gap-2">
      <Badge variant={priorityBadgeVariant(item.priority)}>
        {item.priority || 'P2'}
      </Badge>
      <Badge variant={subjectTypeChipVariant(item.subjectType)}>
        {humanizeSubjectType(item.subjectType)}
      </Badge>
      <Badge variant={humanReviewStateBadgeVariant(item.state)}>
        {item.state.replace('_', ' ')}
      </Badge>
      {isAutoDecided ? (
        <Badge variant="info">
          {typeof item.confidence === 'number'
            ? `AI auto-approved @ ${Math.round(item.confidence * 100)}%`
            : 'AI auto-approved'}
        </Badge>
      ) : (
        typeof item.confidence === 'number' && (
          <Badge variant={confidenceBadgeVariant(item.confidence)}>
            {Math.round(item.confidence * 100)}% confidence
          </Badge>
        )
      )}
      {impactLevel && (
        <Badge variant={impactBadgeVariant(impactLevel)}>
          {impactLevel} impact
        </Badge>
      )}
      {item.decisionCount > 0 && (
        <Badge variant="outline">{item.decisionCount} decisions</Badge>
      )}
    </div>
  );
}
